import { withInstall } from '../_util/type';
import ToolTip from './Tooltip';
export default withInstall(ToolTip);
